<template>
  <img :src="logo" alt="Nummer gegen Kummer Mail-Beratung" class="logo-img" />
</template>

<script>
export default {
  name: 'Logo',
  data: () => ({
    logo: require(`assets/bitmaps/logo-email.png`)
  })
}
</script>
<style lang="scss">
header .e-brand {
  display: flex;
  padding: 0;
  border: 0;
  background: transparent;

  .logo-img {
    display: block;
    width: rem(110px);
    height: auto;

    @include break(xl) {
      width: rem(170px);
    }
  }
}
</style>
